import React from 'react';
import cx from 'clsx';
import classes from './Container.module.scss';

export interface ContainerProps extends React.ComponentPropsWithoutRef<'div'> {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fluid?: boolean;
}

export default function Container({ className, fluid, size = 'md', ...others }: ContainerProps) {
  return (
    <div
      className={cx(
        classes.root,
        [classes[size]],
        {
          [classes.fluid]: fluid,
        },
        className
      )}
      {...others}
    />
  );
}
